import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import "./PackageSelection_NEW.css";
import "./DrawerHoverAnim.css";
import { TopBarView } from "./TopBar";
import { PackageDescriptions } from "./PackageDescriptions";
import packageData from "../packageDetails.json";
import LocalStorageKeys from "../classes/LocalStorageKeys";
const data = packageData;
class PackageData {
}
export const PackageSelectionView = (props) => {
    var _a;
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [hideTopBar, setHideTopBar] = useState(false);
    const isFirstHover = useRef(true);
    const isFirstCarAnimDone = useRef(false);
    const hoveredPackage = useRef("NoPackage");
    // const carImageSetup = useRef(false);
    const isBaseSeries = useRef(((_a = localStorage.getItem(LocalStorageKeys.seriesSelection)) === null || _a === void 0 ? void 0 : _a.includes("Base"))
        ? true
        : false);
    const blockerClass = useRef("interactionBlockStart-PackageSelection");
    const noPackageCarSrc = useRef(isBaseSeries.current
        ? "Images/Packages/Car_Base_NoPackage.webp"
        : "Images/Packages/Car_Carbon_NoPackage.webp");
    const performanceCarSrc = useRef(isBaseSeries.current
        ? "Images/Packages/Car_Base_Performance.webp"
        : "Images/Packages/Car_Carbon_Performance.webp");
    const carImageRef = useRef(noPackageCarSrc.current);
    let inputImageClasses = "inputImage_package punchout";
    let inputTextClasses = "packageText";
    let carImageElem = document.getElementById("carImage2");
    let option1_HighlightElem = document.getElementById("option1_Highlight");
    let option2_HighlightElem = document.getElementById("option2_Highlight");
    // setup class for car Image intro animationend
    const carImageFunc = () => {
        isFirstCarAnimDone.current = true;
        carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.removeEventListener("animationend", carImageFunc);
    };
    setTimeout(() => {
        if (!isFirstCarAnimDone.current) {
            // need elem get to work -.-
            carImageElem = document.getElementById("carImage2");
            isFirstCarAnimDone.current = true;
            carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.addEventListener("animationend", carImageFunc);
        }
    }, 1);
    const makeSelection = (sel) => {
        if (submitDisabled)
            return;
        setSubmitDisabled(true);
        // trigger animation, then go to next view afterwards
        const forground = Array.from(document.getElementsByClassName("foreground_IntroAnim"));
        forground.forEach((element) => {
            element.className = "foreground_OutroAnim";
        });
        const background = Array.from(document.getElementsByClassName("backgroundClass_Intro"));
        background.forEach((element) => {
            element.className = "backgroundClass_Outro";
        });
        const optionElement = Array.from(document.getElementsByClassName("optionHolder_Intro"));
        optionElement.forEach((element) => {
            element.className = "optionHolder_Outro";
        });
        const carImage = document.getElementById("carImage2");
        carImage === null || carImage === void 0 ? void 0 : carImage.setAttribute("class", "carImageClass_Outro");
        // block user interaction
        const blocker = Array.from(document.getElementsByClassName("interactionBlockStart-PackageSelection"));
        blocker.forEach((element) => {
            element.className = "interactionBlockEnabled-PackageSelection";
        });
        // hide top bar
        setHideTopBar(true);
        setTimeout(() => {
            props.PackageSelect(sel);
        }, 1700);
        // add class to elements
        const imgArray = Array.from(document.getElementsByClassName(inputImageClasses));
        const textArray = Array.from(document.getElementsByClassName(inputTextClasses));
        let num = 1;
        textArray.forEach((element) => {
            if (num >= 3)
                num = 2;
            const newClass = " fadingOutImage" + num.toString();
            const oldClass = inputTextClasses;
            inputTextClasses += newClass;
            num++;
            element.className = inputTextClasses;
            inputTextClasses = oldClass;
        });
        num = 1;
        imgArray.forEach((element) => {
            const newClass = " fadingOutImage" + num.toString();
            const oldClass = inputImageClasses;
            inputImageClasses += newClass;
            num++;
            element.className = inputImageClasses;
            inputImageClasses = oldClass;
        });
    };
    // car image change logic
    const carImageFadeOut = (carPackage) => {
        if (carPackage === "NoPackage")
            carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.setAttribute("src", noPackageCarSrc.current);
        else
            carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.setAttribute("src", performanceCarSrc.current);
        carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.setAttribute("class", "carImage_FadeIn");
        // TODO:P remove time and set to animationend
        // it will suck to not do this >:(
        setTimeout(() => {
            const blocker = document.getElementById("interactionBlocker-PackageSelection");
            blocker === null || blocker === void 0 ? void 0 : blocker.setAttribute("class", "interactionBlockDisabled-PackageSelection");
        }, 550);
        carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.removeEventListener("animationend", myListener);
    };
    function addListenerWithParam(test) {
        return function (event) {
            carImageFadeOut(test);
        };
    }
    let myListener = addListenerWithParam(hoveredPackage.current);
    const handleOptionHover = (packageHovered) => {
        /* logic for package highlight & car image shown */
        if (!carImageElem) {
            carImageElem = document.getElementById("carImage2");
        }
        if (!option1_HighlightElem) {
            option1_HighlightElem = document.getElementById("option1_Highlight");
        }
        if (!option2_HighlightElem) {
            option2_HighlightElem = document.getElementById("option2_Highlight");
        }
        if (hoveredPackage.current === packageHovered)
            return;
        hoveredPackage.current = packageHovered;
        myListener = addListenerWithParam(hoveredPackage.current);
        if (packageHovered === "NoPackage") {
            if (!isFirstHover.current && hoveredPackage.current === packageHovered) {
                // carImageElem?.setAttribute("src", noPackageCarSrc.current);
                option1_HighlightElem === null || option1_HighlightElem === void 0 ? void 0 : option1_HighlightElem.setAttribute("class", "optionFadeIn");
                option2_HighlightElem === null || option2_HighlightElem === void 0 ? void 0 : option2_HighlightElem.setAttribute("class", "optionFadeOut");
                carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.setAttribute("class", "carImage_FadeOut");
                // block user interaction
                const blocker = document.getElementById("interactionBlocker-PackageSelection");
                blocker === null || blocker === void 0 ? void 0 : blocker.setAttribute("class", "interactionBlockEnabled-PackageSelection");
                carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.addEventListener("animationend", myListener);
            }
            else {
                isFirstHover.current = false;
            }
            // option1_HighlightElem?.setAttribute("style", "opacity: 1");
            // option2_HighlightElem?.setAttribute("style", "opacity: 0");
        }
        else if (hoveredPackage.current === packageHovered) {
            isFirstHover.current = false;
            option1_HighlightElem === null || option1_HighlightElem === void 0 ? void 0 : option1_HighlightElem.setAttribute("class", "optionFadeOut");
            option2_HighlightElem === null || option2_HighlightElem === void 0 ? void 0 : option2_HighlightElem.setAttribute("class", "optionFadeIn");
            carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.setAttribute("class", "carImage_FadeOut");
            carImageElem === null || carImageElem === void 0 ? void 0 : carImageElem.addEventListener("animationend", myListener);
            // block user interaction
            // blockerClass.current = "interactionBlockEnabled-PackageSelection";
            const blocker = document.getElementById("interactionBlocker-PackageSelection");
            blocker === null || blocker === void 0 ? void 0 : blocker.setAttribute("class", "interactionBlockEnabled-PackageSelection");
        }
    };
    const stuff = (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "packagesRoot", className: "black-background" }, { children: [_jsx("div", { id: "backgroundColor", className: "backgroundClass_Intro" }), _jsxs("div", Object.assign({ id: "packagesParent" }, { children: [_jsx("div", { id: "foreground", className: "foreground_IntroAnim" }), _jsx("div", Object.assign({ id: "carImageDiv" }, { children: _jsx("img", { id: "carImage2", className: "carImageClass_Intro", alt: "ImageOfCar", src: carImageRef.current }) })), _jsx("div", { id: "interactionBlocker-PackageSelection", className: blockerClass.current }), _jsxs("div", Object.assign({ id: "optionHolder", className: "optionHolder_Intro" }, { children: [" ", _jsxs("div", Object.assign({ id: "option1of2", onMouseEnter: (e) => {
                                        handleOptionHover("NoPackage");
                                    } }, { children: [_jsx("img", { id: "option1_Highlight", className: "Start_optionFadeIn", alt: "highlighted border", src: "Images/Packages/Highlight_2Option_Small.png" }), _jsx("h2", { children: "No Package" }), _jsx("h3", { children: "!SecretText!" }), _jsx("img", { className: "lineTop", src: "Images/Packages/Line.png", alt: "img of a line" }), _jsx(PackageDescriptions, { descriptionStrings: data.NoPackage ? data.NoPackage : ["Error Reading Data"] }), _jsx("img", { className: "lineBottom newClass secondClass", src: "Images/Packages/Line.png", alt: "img of a line" }), _jsx("button", Object.assign({ onClick: () => makeSelection("NoPackage") }, { children: "Select" }))] })), _jsxs("div", Object.assign({ id: "option2of2", onMouseEnter: (e) => {
                                        handleOptionHover("Performance");
                                    } }, { children: [_jsx("img", { id: "option2_Highlight", className: "", alt: "highlighted border", src: "Images/Packages/Highlight_2Option_Large.png" }), _jsx("h2", { children: "Performance Package" }), _jsx("h3", { children: "Includes Lightweight Package" }), _jsx("img", { className: "lineTop", src: "Images/Packages/Line.png", alt: "img of a line" }), _jsx(PackageDescriptions, { descriptionStrings: data.Performance ? data.Performance : ["Error Reading Data"] }), _jsx("img", { className: "lineBottom", src: "Images/Packages/Line.png", alt: "img of a line" }), _jsx("button", Object.assign({ onClick: () => makeSelection("Performance") }, { children: "Select" }))] }))] })), _jsx("div", Object.assign({ id: "backDiv", style: {
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                color: "black",
                                zIndex: "12",
                                overflow: "hidden",
                            } }, { children: !hideTopBar && (_jsx("button", Object.assign({ id: "backButton", onClick: () => makeSelection("back") }, { children: _jsx("span", { children: "return to previous page" }) }))) }))] })), " ", _jsx(TopBarView, { BarSelect: 3, DisplayText: "a package to continue", SetToHide: hideTopBar })] })) }));
    return stuff;
};
